export default "__VITE_ASSET__DdOs8zFs__"